import React, {Component} from 'react'
import styles from './Logo.module.css'
import logo from "../../assets/img/ffb_logo.svg"
import  './Logo.css';


class Logo extends Component {


  render() {

    const {searching} = this.props

    return (

      <section className={searching ? styles.LogoModuleHide : styles.LogoModule}>
        <div className="container">
          <div className="row">
            <div className="columns col-xs-12 col-sm-6 col-md-8">
              <div className={styles.Logo + " logo inline-logo"}>
                <a href="https://www.finansforbundet.dk" target="_blank" rel="noopener noreferrer">
                  <img src={logo} alt="Finansforbundet logo" />
                </a>
              </div>
            </div>
            <div className="columns col-xs-12 col-sm-6 col-md-4">
              <div className={styles.DisclaimerText}>
                Finansforbundet benytter sig af troværdige eksterne kilder til at forklare og definere ordene på sitet. 
                  Der skal have været mindst to troværdige kilder til hvert ord. Hvis forklaringerne har været divergerende, har der været søgt flere kilder. 
                
              </div>
            </div>
          </div>
        </div>
      </section>

    )
  }
}

export default Logo
